<script>
import axios from "axios";
import Swal from "sweetalert2";
import { ref } from "vue";
import moment from "moment";

export default {
  name: "absensi-peserta",
  props: ["idPembelajaran"],
  data() {
    return {
      axiosCatchError: null,
      data_peserta: [],
      data_tanggal: [],
      tanggal_mulai: null,
      tanggal_selesai: null,
      jumlah_peserta_bersedia: "0 Peserta",
      jumlah_peserta_tidak_bersedia: "0 Peserta",
      total_peserta: "0 Peserta",
      jumlah_peserta_menunggu_konfirmasi: "0 Peserta",
      total_hari: 0,
      update_kehadiran: false,
      statusKehadiran: "NOT READY",
      lockKehadiran: false,
      file_qr_code: null,
      tgl_hari_ini: moment(ref(new Date())).format("YYYY-MM-DD"),
    };
  },
  mounted() {
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
    });

    var config = {
      method: "get",
      url:
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "transactions/pra-pelaksanaan/absensi-peserta",
      params: {
        id_pembelajaran: this.idPembelajaran,
      },
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };

    axios(config)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          self.tanggal_mulai = response_data_fix.tanggal_mulai;
          self.tanggal_selesai = response_data_fix.tanggal_selesai;
          self.jumlah_peserta_bersedia = response_data_fix.peserta_bersedia;
          self.jumlah_peserta_tidak_bersedia =
            response_data_fix.peserta_tidak_bersedia;
          self.jumlah_peserta_menunggu_konfirmasi =
            response_data_fix.peserta_menunggu_konfirm;
          self.total_peserta = response_data_fix.total_peserta;
          self.data_tanggal = JSON.parse(response_data_fix.data_tanggal);
          self.total_hari = response_data_fix.total_hari;
          self.data_peserta = response_data_fix.data_peserta;
          self.statusKehadiran = response_data_fix.status_kehadiran;

          if (self.tgl_hari_ini > response_data_fix.tanggal_selesai) {
            self.lockKehadiran = true;
          } else {
            self.lockKehadiran = false;
          }

          self.file_qr_code =
            process.env.VUE_APP_BACKEND_URL + response_data_fix.qr_code_path;

          Swal.close();
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
    checkValueAbsensi() {
      let self = this;
      console.log(self.data_peserta);
    },
    ubahKehadiran(status) {
      let self = this;
      self.update_kehadiran = status;
    },
    StoreDataAbsensi() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "put",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/absensi-peserta",
        data: {
          id_pembelajaran: this.idPembelajaran,
          data_peserta: JSON.stringify(self.data_peserta),
          update_kehadiran: self.update_kehadiran,
          user_id: localStorage.getItem("session_user_id"),
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data Absensi Berhasil Disimpan.",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              self.$emit("close-form-absensi-peserta");
            }
          });
        })
        .catch(function (error) {
          self.axiosCatchErrorProfile = error.response.data.data;
          Swal.close();
        });
    },
    exportAbsensiPeserta() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading Ekspor Data ...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      var config = {
        method: "get",
        responseType: "arraybuffer",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/peserta/export-absensi",
        params: {
          idPembelajaran: this.idPembelajaran,
        },
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          Accept: "application/vnd.ms-excel",
        },
      };

      axios(config).then(function (response) {
        if (response.data.meta?.code == 500) {
          Swal.close();
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "Error, mohon coba lagi.",
          });
        } else {
          Swal.close();
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/csv" })
          );
          // console.log(url);
          const link = document.createElement("a");
          link.href = url;
          const timestamp = moment().format("YYYYMMDD_HHmmss");
          link.setAttribute(
            "download",
            "export-peserta-pembelajaran-" + timestamp + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
        }
      });
    },
  },
};
</script>
<style>
th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <b-form class="p-2" @submit.prevent="StoreDataAbsensi">
    <div class="row">
      <div class="col-12">
        <div v-if="axiosCatchError">
          <div
            class="alert alert-danger"
            v-if="
              typeof axiosCatchError === 'string' ||
              axiosCatchError instanceof String
            "
          >
            {{ axiosCatchError }}
          </div>
          <div class="alert alert-danger" role="alert" v-else>
            <div v-for="(errorArray, idx) in axiosCatchError" :key="idx">
              <div v-for="(allErrors, idx) in errorArray" :key="idx">
                <span class="text-danger">{{ allErrors[0] }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-6 mt-3">
            <div class="form-group">
              <label for="">Tanggal Mulai</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="tanggal_mulai"
              />
            </div>
          </div>
          <div class="col-6 mt-3">
            <div class="form-group">
              <label for="">Tanggal Selesai</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="tanggal_selesai"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Jumlah Peserta Menunggu Konfirmasi</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="jumlah_peserta_menunggu_konfirmasi"
              />
            </div>
          </div>
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Jumlah Peserta Bersedia</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="jumlah_peserta_bersedia"
              />
            </div>
          </div>
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Jumlah Peserta Tidak Bersedia</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="jumlah_peserta_tidak_bersedia"
              />
            </div>
          </div>
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Total Peserta</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="total_peserta"
              />
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div class="col-12">
        <div class="table-responsive text-nowrap">
          <table class="table mb-0 mt-0 table-sm table-bordered table-hover">
            <thead class="bg-dark text-center text-white">
              <tr>
                <th rowspan="2" style="width: 25px; vertical-align: middle">
                  No
                </th>
                <th rowspan="2" style="width: 75px; vertical-align: middle">
                  NIP
                </th>
                <th rowspan="2" style="width: 175px; vertical-align: middle">
                  Nama
                </th>
                <th rowspan="2" style="width: 175px; vertical-align: middle">
                  Jabatan
                </th>
                <th v-bind:colspan="total_hari">Absensi</th>
              </tr>
              <tr>
                <th
                  style="width: 60px"
                  v-for="(row_tanggal, key_tanggal) in data_tanggal"
                  :key="key_tanggal"
                >
                  {{ row_tanggal }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row_data, key_data) in data_peserta" :key="key_data">
                <td class="text-center">{{ key_data + 1 }}.</td>
                <td class="text-center">{{ row_data.user.username }}</td>
                <td>{{ row_data.user.name }}</td>
                <td>{{ row_data.user.jabatan_name }}</td>
                <td
                  v-if="row_data.pembelajaran_absensi == ''"
                  class="text-center"
                  v-bind:colspan="total_hari"
                  style="color: red"
                >
                  Peserta Belum Konfirmasi Kehadiran / Data Absensi Tidak
                  Tersedia
                </td>
                <td
                  v-else
                  v-for="(
                    row_absensi, key_absensi
                  ) in row_data.pembelajaran_absensi"
                  :key="key_absensi"
                  class="text-center"
                >
                  <div v-if="lockKehadiran == false">
                    <input
                      type="checkbox"
                      :value="'t'"
                      :unchecked-value="'f'"
                      v-model="row_absensi.pba_kehadiran"
                      @change="checkValueAbsensi()"
                    />
                  </div>
                  <div v-else>
                    <div v-if="row_absensi.pba_kehadiran == true">
                      <div
                        class="badge badge-pill badge-soft-success font-size-11"
                      >
                        <i class="fa fa-check"></i>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="badge badge-pill badge-soft-danger font-size-11"
                      >
                        <i class="fa fa-times"></i>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr />
      </div>
    </div>
    <div v-if="lockKehadiran == false">
      <div v-if="statusKehadiran == 'READY'">
        <div class="row">
          <div class="col-md-4">&nbsp;</div>
          <div class="col-md-8">
            <div class="text-end">
              <a
                role="button"
                class="btn btn-info"
                v-bind:href="file_qr_code"
                target="_blank"
              >
                <i class="fa fa-qrcode"></i> QR Code Absensi
              </a>
              &nbsp;
              <b-button
                type="button"
                variant="success"
                @click="exportAbsensiPeserta()"
              >
                <i class="fa fa-file-excel"></i> Export Excel
              </b-button>
              &nbsp;
              <b-button
                type="submit"
                variant="info"
                @click="ubahKehadiran(false)"
              >
                <i class="fa fa-save"></i> Simpan
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-4">&nbsp;</div>
          <div class="col-md-8">
            <div class="text-end">
              <a
                role="button"
                class="btn btn-info"
                v-bind:href="file_qr_code"
                target="_blank"
              >
                <i class="fa fa-qr"></i> QR Code Absensi
              </a>
              &nbsp;
              <b-button
                type="button"
                variant="success"
                @click="exportAbsensiPeserta()"
              >
                <i class="fa fa-file-excel"></i> Export Excel
              </b-button>
              &nbsp;
              <b-button
                type="submit"
                variant="info"
                @click="ubahKehadiran(false)"
              >
                <i class="fa fa-save"></i> Simpan Sebagai Rekapan
              </b-button>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-4">&nbsp;</div>
        <div class="col-md-8">
          <div class="text-end">
            <b-button
              type="button"
              variant="success"
              @click="exportAbsensiPeserta()"
            >
              <i class="fa fa-file-excel"></i> Export Excel
            </b-button>
            &nbsp;
            <b-button
                v-if="statusKehadiran == 'NOT READY'"
                type="submit"
                variant="primary"
                @click="ubahKehadiran(true)"
              >
                <i class="fa fa-save"></i> Konfirmasi LMS
              </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>
